<template>
  <img src="https://www.truemetrics.cn/assets/img_site/TMlogo.png" alt="" class="logo logo-lg" />
</template>

<script lang="ts" setup></script>
